import React from 'react'
import { Clock } from 'lucide-react'
import { formatCourseWorkloadHHMM } from '../lib/courseWorkload'

export default function CourseWorkloadBadge({
  workload,
  wrapperClassName = 'absolute bottom-2 right-2 z-10',
}) {
  return (
    <div className={wrapperClassName}>
      <span className="bg-slate-950/82 backdrop-blur-sm text-slate-100 text-[11px] font-semibold px-2.5 py-1 rounded-md border border-slate-500/70 flex items-center gap-1.5 shadow-md ring-1 ring-black/30">
        <Clock size={11} />
        {formatCourseWorkloadHHMM(workload) || '00:00'}
      </span>
    </div>
  )
}
